import { helper } from '@ember/component/helper';
import { htmlSafe as h } from '@ember/template';

export default helper(function htmlSafe([str]) {
  return h(str);
});
